import { render, staticRenderFns } from "./Monos.vue?vue&type=template&id=b2bca9c2"
import script from "./Monos.vue?vue&type=script&lang=js"
export * from "./Monos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports